import { getApiUrl } from "../../constants/pathConstants"
import { adminStateData } from "../../data/adminStateData"
import { userStateData } from "../../data/userStateData"
import { API_END_POINT_GET_ALL_CUSTOMER_DETAILS, API_END_POINT_GET_ALL_INSTRUCTOR_DETAILS, API_END_POINT_GET_ALL_INTERACTIONS, API_END_POINT_GET_INSTRUCTOR_USER_DATA } from "../endPoints"
import { AdminGetCustomersResponse, AdminGetInsteractionsResponse, AdminGetInstructorsResponse, UserData } from "../types"

class AdminConnector {
	requestInProgress: boolean = false

	public async performGetAdminCustomersRequest(statusFlag?: string | undefined): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [AdminConnector] performGetAdminCustomersRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true

				const urlParams = new URLSearchParams()
				if (statusFlag) {
					urlParams.append("statusFlag", statusFlag)
				}
				
				await fetch(`${getApiUrl()}${API_END_POINT_GET_ALL_CUSTOMER_DETAILS}?${urlParams}`)
					.then((res) => res.json())
					.then((data: AdminGetCustomersResponse) => {
						if (data.customers) {
							adminStateData.setCustomers(data.customers)
						}
					})
					.catch((error) => {
						console.log(error)
					})
						
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[AdminConnector] - performGetAdminCustomersRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performGetAdminInstructorsRequest(statusFlag?: string | undefined): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [AdminConnector] performGetAdminInstructorsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true

				const urlParams = new URLSearchParams()
				if (statusFlag) {
					urlParams.append("statusFlag", statusFlag)
				}
				
				await fetch(`${getApiUrl()}${API_END_POINT_GET_ALL_INSTRUCTOR_DETAILS}?${urlParams}`)
					.then((res) => res.json())
					.then((data: AdminGetInstructorsResponse) => {
						if (data.instructors) {
							adminStateData.setInstructors(data.instructors)
						}
					})
					.catch((error) => {
						console.log(error)
					})
						
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[AdminConnector] - performGetAdminInstructorsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performGetAdminInstructorRequest(instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performGetAdminInstructorRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				await fetch(`${getApiUrl()}${API_END_POINT_GET_INSTRUCTOR_USER_DATA}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": instructorId
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status == 'success') {
							userStateData.setUserData(data.userData as UserData)
						}
					})
					.catch((error) => {
						console.log(error)
					})
				this.requestInProgress = false
				return adminStateData.loggedIn
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performGetAdminInstructorRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performGetAdminChatsRequest(statusFlag?: string | undefined): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [AdminConnector] performGetAdminChatsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true

				const urlParams = new URLSearchParams()
				if (statusFlag) {
					urlParams.append("statusFlag", statusFlag)
				}
				
				await fetch(`${getApiUrl()}${API_END_POINT_GET_ALL_INTERACTIONS}?${urlParams}`)
					.then((res) => res.json())
					.then((data: AdminGetInsteractionsResponse) => {
						if (data.interactions) {
							adminStateData.setInteractions(data.interactions)
						}
					})
					.catch((error) => {
						console.log(error)
					})
						
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[AdminConnector] - performGetAdminChatsRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const adminConnector: AdminConnector = new AdminConnector()